
import { toast } from "react-toastify";
import { useUnAssignEquipmentMutation } from "../../../../store/builder/inspections.api";
import GeneralModal from "../../../../components/GeneralModal/GeneralModal";
import { useTranslation } from "../../../../hooks/useTranslation";
const UnAssignModal = ({ equipment, setIsOpen, getEquipmentsInitial }) => {
    const [
    unAssign,
      {
        isLoading: isUnAssignLoading
      }
    ] = useUnAssignEquipmentMutation();
    const {t} = useTranslation();
    const handleUnAssign = () => {
        unAssign(equipment.id).then((res) => {
            if (res?.data?.message) {
                toast.success(res?.data?.message);
            }
            if (res?.error) {
                toast.error(res?.error?.data?.message);
            }
            setIsOpen(false);
            getEquipmentsInitial();
        });
    }
    
    return (
      <GeneralModal
        title={t('equipmentTable.modals.unassign.title')}
        onSubmit={handleUnAssign}
        onClose={() => setIsOpen(false)}
        disableSubmit={isUnAssignLoading}
        btnType={isUnAssignLoading ? 'disabled' : 'save'}
      >
        <div>
          <p>{t('equipmentTable.messages.unassignEquipment')}</p>
        </div>
      </GeneralModal>
    );
};
  
export default UnAssignModal;